<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/03_Parchi-Riserve/03D_Aspromonte_Pietra-Castello.jpg">
<div class="content">
    <h1>Calabria</h1>
    <h3>Parco nazionale dell’Aspromonte</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a class="active">Parco nazionale dell’Aspromonte</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            Il parco è ricco di meravigliosi sentieri naturalistici da percorrere in bicicletta oppure a cavallo. 
            La natura è regina indiscussa di questa Riserva che, grazie alla presenza di numerosi corsi d’acqua, 
            è rigogliosa, ricca di boschi di faggi e, nelle aree più vicine alla costa, di splendidi oleandri e tamerici. 
            Addentrandosi e salendo di quota - si arriva fino a 2000 metri - ci si può immergere invece in favolose pinete di pini larici,
             alberi simbolo dell’Aspromonte. Tra i patrimoni dell’umanità il Parco custodisce otto geositi nella Rete Europea e Globale dei Geoparchi e 
             la faggeta vetusta di Valle Infernale. Intraprendere un viaggio alla scoperta di questo Parco significa anche tornare alle radici della 
             gastronomia delle zone montane calabresi, basata sui prodotti di un’economia tipicamente pastorale e contadina,
              o su eccellenze dell’agricoltura come il bergamotto. Viaggiando attraverso l’Aspromonte è possibile ritrovare anche alcune rarità gastronomiche,
               come il formaggio pecorino dell’area grecanica, realizzato con uno stampo di legno molto particolare, la musulupa, 
               che lascia sulla forma un’impronta circolare raffigurante figure umane e pupazzi. 
        </p>
    </div>
</div>
<br>
<br>
<div class="divider">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-10 col-xl-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco nazionale dell’Aspromonte.</p>
    </div>
    <div class="col-2 col-xl-1">
        <img style="width: 65%;" src="../../../assets/images/logo-parco-top2.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-12 col-xl-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gerace</h1>
                        <a (click)="goToGerace()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Area grecanica</h1>
                        <a (click)="goToAreaGrecanica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider">
    
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>